import React from 'react';
import { DatabaseIcon, StorageIcon, SignedNoteIcon } from 'components/icons';

import { SOLUTIONS } from 'context/solutions/constants';

export const products = [
  {
    title: SOLUTIONS.ACCESS_AND_RETENTION.TITLE,
    link: SOLUTIONS.ACCESS_AND_RETENTION.LINK,
    icon: <DatabaseIcon />,
    description: `
      AFEX provides solutions to problems of farmer identification, productivity 
      and benefit sharing. Our products in this category include services and 
      structured programmes that lead to higher productivity and returns for farmers 
      and investors respectively.`,
  },
  {
    title: SOLUTIONS.BIG_DATA_ANALYTICS.TITLE,
    link: SOLUTIONS.BIG_DATA_ANALYTICS.LINK,
    icon: <StorageIcon tag="img" />,
    description: `
    The products under this category focus on granular data capture and analysis for 
    investors in agricultural commodities. Clients for the products and platform in this 
    category gain valuable insights that can help them assess and manage production and 
    price risk for the sector.`,
  },
  {
    title: SOLUTIONS.EFFICIENT_MARKETS.TITLE,
    link: SOLUTIONS.EFFICIENT_MARKETS.LINK,
    icon: <SignedNoteIcon />,
    description: `
      AFEX built a platform that facilitates effective trade and settlement on commodity transactions. 
      The platform supports securitization and structured trade finance for agricultural 
      commodities, which allows investors diversify their portfolios with innovative 
      commodity-backed products.`,
  },
];
